<script setup lang="ts">
import IconMaterialSymbolsNorthEastRounded from '~icons/material-symbols/north-east-rounded';
import IconPilarHomesNaturalEvolution from '~icons/pilar/pilar-homes-natural-evolution.svg';
import IconPilarTriangle from '~icons/pilar/pilar-triangle.svg';

interface Props {
	title: string;
	description: string;
	cta: string;
}

defineProps<Props>();
const emits = defineEmits<{
	(e: 'searchProperties'): void;
}>();
</script>

<template>
	<section class="bg-white">
		<Container class="!pt-11 md:!pt-20">
			<div
				class="flex flex-col gap-10 md:items-center md:justify-center md:gap-20 lg:items-start lg:justify-start"
			>
				<div class="flex flex-col gap-y-5">
					<IconPilarHomesNaturalEvolution
						class="h-6 w-[166px] md:h-10 md:w-[276px]"
					/>

					<SkewRectangleText
						rectangle-class="bg-secondary max-w-[365px] md:max-w-[476px] -left-9"
					>
						<template #default>
							<span class="relative z-10">
								<span
									class="font-matter-sq text-[28px] font-normal leading-[150%] tracking-[-0.56px] text-primary md:text-[2.75rem] md:tracking-[-0.88px]"
								>
									{{ title }}
								</span>
							</span>
						</template>
					</SkewRectangleText>
				</div>
				<div class="flex w-full flex-col md:max-h-[320px] md:flex-row">
					<div class="flex w-full justify-end md:w-1/2">
						<NuxtImg
							loading="lazy"
							:src="'/images/about/pilar_homes_natural_evolution.webp'"
							alt="Pilar"
							format="webp"
							width="640"
							height="320"
							placeholder
							class="size-full max-h-[240px] object-cover md:max-h-[320px]"
						/>
					</div>
					<div
						class="relative flex flex-col gap-8 bg-secondary p-6 md:w-1/2 md:py-9 md:pl-9 md:pr-[4.5rem]"
					>
						<IconPilarTriangle
							class="absolute right-7 top-7 hidden size-5 md:block"
						/>
						<div class="flex">
							<p
								class="self-stretch text-sm font-normal leading-[28px] text-primary-light-3 xl:text-xl xl:leading-[200%]"
							>
								{{ description }}
							</p>
						</div>
						<div>
							<NuxtLink
								v-slot="{ href }"
								custom
								to="/venda/imoveis/sao-paulo-sp-brasil"
							>
								<Button
									as="a"
									:href="href"
									variant="primary"
									class="flex max-h-[44px] max-w-[161px] gap-2 px-4 text-sm"
									@click="emits('searchProperties')"
								>
									<span>{{ cta }}</span>
									<IconMaterialSymbolsNorthEastRounded
										class="size-6 fill-white text-lg text-white"
									/>
								</Button>
							</NuxtLink>
						</div>
					</div>
				</div>
			</div>
		</Container>
	</section>
</template>
